window.Vivense = window.Vivense || {};

Vivense.blockUtil = (function ($) {

    var exports = {};

    var blockUIOpts = {
        message: '<div class="vivense-loading-icon"><img src="/img/page-loading-vivense-logo.svg"></div>',
        fadeIn: 150,
        fadeOut: 50,
        css : {
            border: 'none',
            backgroundColor: 'none'
        },
        overlayCSS : {
            backgroundColor: '#fff',
            opacity: 0.6,
            cursor: null,
            color: '#fff'
        }
    };


    function blockUI(item) {
        item.block(blockUIOpts);
    }

    function unblockUI(item) {
        item.unblock(blockUIOpts);
    }
    exports.blockUI = blockUI;
    exports.unblockUI = unblockUI;

    return exports;
})(jQuery);
